import { render, staticRenderFns } from "./InvoicesForm.vue?vue&type=template&id=5b6afa46&"
import script from "./InvoicesForm.vue?vue&type=script&lang=js&"
export * from "./InvoicesForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesForm.vue?vue&type=style&index=0&id=5b6afa46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports